var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oeamtc-field"},[_c('a',{staticClass:"oeamtc-button oeamtc-button--w100",attrs:{"href":_setup.appointmentBookingUrl}},[_c(_setup.IconCalender),_c('span',{staticClass:"oeamtc-button__text"},[_vm._v("Jetzt Termin buchen")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }